import { useRef } from "react"

export function useStableValue<T>(
  value: T,
  shouldUpdate: (value: T) => boolean = (val) => val !== undefined,
) {
  const ref = useRef<T>(value)

  if (shouldUpdate(value)) {
    ref.current = value
  }

  return ref.current
}
